import { render, staticRenderFns } from "./BanAdd.vue?vue&type=template&id=5cc6698e&"
import script from "./BanAdd.vue?vue&type=script&lang=js&"
export * from "./BanAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports